var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M816.244,4359l4.182,4.182,8.762-8.763","transform":"translate(-815.537 -4353.712)","fill":"none","stroke":"currentColor","strokeWidth":"2"}));
}

Check.defaultProps = {"width":"14.359","height":"10.884","viewBox":"0 0 14.359 10.884"};

module.exports = Check;

Check.default = Check;
